import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import DashboardLayout from '../Layout/DashboardLayout';
import LoadingSpinner from '../Common/LoadingSpinner';
import { requestHelpers } from '../../services/api';
import './WhatsAppFlows.css';

const WhatsAppFlows = () => {
    const [flows, setFlows] = useState([]);
    const [templates, setTemplates] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [newFlow, setNewFlow] = useState({ name: '', categories: ['OTHER'] });

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            setLoading(true);
            const [flowsRes, templatesRes] = await Promise.all([
                requestHelpers.get('/whatsapp-flows'),
                requestHelpers.get('/whatsapp-flows/templates')
            ]);
            
            if (flowsRes.success) setFlows(flowsRes.data);
            if (templatesRes.success) setTemplates(templatesRes.data);
        } catch (error) {
            toast.error('Failed to load flows');
        } finally {
            setLoading(false);
        }
    };

    const handleCreateFlow = async (template = null) => {
        try {
            const flowData = template 
                ? { name: `${template.name}_${Date.now()}`, categories: [template.category] }
                : newFlow;

            const result = await requestHelpers.post('/whatsapp-flows', flowData);

            if (result.success) {
                if (template) {
                    await requestHelpers.post(`/whatsapp-flows/${result.data.flowId}/assets`, {
                        flowJSON: template.json
                    });
                }
                toast.success('Flow created successfully');
                setShowCreateModal(false);
                fetchData();
            }
        } catch (error) {
            toast.error('Flow creation failed');
        }
    };

    const handlePublish = async (flowId) => {
        try {
            const result = await requestHelpers.post(`/whatsapp-flows/${flowId}/publish`);
            if (result.success) {
                toast.success('Flow published!');
                fetchData();
            }
        } catch (error) {
            toast.error('Publishing failed');
        }
    };

    if (loading) return <LoadingSpinner />;

    return (
        <DashboardLayout>
            <div className="flows-container">
                <header className="page-header">
                    <div>
                        <h1>WhatsApp Flows</h1>
                        <p>Build screen-based interactive forms for collection and booking.</p>
                    </div>
                    <button className="btn-primary" onClick={() => setShowCreateModal(true)}>
                        <i className="fas fa-plus"></i> Create Flow
                    </button>
                </header>

                <div className="flows-grid">
                    {flows.map(flow => (
                        <div key={flow.flowId} className="flow-card">
                            <div className="flow-badge">{flow.status}</div>
                            <h3>{flow.name}</h3>
                            <p className="flow-id">ID: {flow.flowId}</p>
                            <div className="flow-actions">
                                {flow.status === 'DRAFT' && (
                                    <button className="btn-publish" onClick={() => handlePublish(flow.flowId)}>
                                        Publish
                                    </button>
                                )}
                                <button className="btn-preview" onClick={() => window.open(flow.previewUrl, '_blank')}>
                                    Preview
                                </button>
                            </div>
                        </div>
                    ))}
                </div>

                {showCreateModal && (
                    <div className="modal-overlay">
                        <div className="modal-content">
                            <h2>Choose a Starting Point</h2>
                            <div className="template-grid">
                                {templates.map(tmp => (
                                    <div key={tmp.name} className="template-card" onClick={() => handleCreateFlow(tmp)}>
                                        <h4>{tmp.name}</h4>
                                        <p>{tmp.description}</p>
                                    </div>
                                ))}
                                <div className="template-card custom" onClick={() => handleCreateFlow()}>
                                    <h4>Start from Scratch</h4>
                                    <p>Design your own flow JSON.</p>
                                </div>
                            </div>
                            <button className="btn-close" onClick={() => setShowCreateModal(false)}>Close</button>
                        </div>
                    </div>
                )}
            </div>
        </DashboardLayout>
    );
};

export default WhatsAppFlows;
